import apiClient from '../api/httpClient';
import endpoints from '../api/endpoints';
import { getErrorMessage } from '../utils/errorUtils';

const USER_STORAGE_KEY = 'iot-user';

function getLocalUser() {
    try {
        const raw = localStorage.getItem(USER_STORAGE_KEY);
        if (!raw) return null;
        return JSON.parse(raw);
    } catch (err) {
        return null;
    }
}

export function loadUserSettings(key, authenticatedUser = null) {
    // AuthProvider's user is populated from the Users table by login/auth-check.
    // Prefer it over the local cache so a newly loaded session always uses the
    // current database settings.
    const user = authenticatedUser?.id ? authenticatedUser : getLocalUser();
    return user?.settings?.[key] || {};
}

export function updateUserInLocalStorage(userObject) {
    try {
        if (!userObject || Object.keys(userObject).length === 0) {
            localStorage.removeItem(USER_STORAGE_KEY);
            return;
        }

        localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(userObject));
    } catch (err) {
        console.error("Failed to save user to localStorage:", err);
    }
}

export async function syncUserSettingsToDB(key, settings) {
    const user = getLocalUser();

    if (!user?.id || !key || !settings) {
        return false;
    }

    try {
        const payload = {
            settings: { [key]: settings }
        };

        const res = await apiClient.post(
            endpoints.user.saveSettings(user.id),
            payload,
            { withCredentials: true }
        );
        if (res.data?.status !== 'OK') {
             throw new Error("Server acknowledged the request but reported an issue.");
        }

        return true;
    } catch (err) {
        console.error(
            `Error syncing settings for key '${key}':`, 
            getErrorMessage(err)
        );
        return false;
    }
}
